$(document).ready(function(){
    setTimeout(function() {
        $('.swym-wishlist-collections-v2-container button.swym-wishlist-collections-v2').each(function () {
            var pressed = $(this).attr('aria-pressed');
            var card = $(this)
            .parents('.swym-wishlist-collections-v2-container').parents('.card-wrapper.product-card-wrapper').find('.heart-view-wrap');
            if (pressed === 'true') {
                card.addClass('active');
            } else {
                card.removeClass('active');
            }
        });
    },2500);
});


// QUICK VIEW CLICK
function quick(el) {
    const wrapper = el.closest('.card-wrapper.product-card-wrapper.underline-links-hover');
    if (!wrapper) return;

    const btn = wrapper.querySelector('.quick-add.no-js-hidden modal-opener .quick-add__submit.button.button--full-width.button--secondary');
    if (btn) {
        btn.click();
    }
}

// HEART/WISHLIST CLICK
function heart(el) {
    const wrapper = el.closest('.card-wrapper.product-card-wrapper.underline-links-hover');
    if (!wrapper) return;
    const wishlistContainer = wrapper.querySelector('.swym-wishlist-collections-v2-container');
    if (wishlistContainer) {
        wishlistContainer.click();
    }

    // Wait for SWYM to update aria-pressed
    setTimeout(() => {
        document.querySelectorAll('.swym-wishlist-collections-v2-container button.swym-wishlist-collections-v2').forEach(btn => {
            const pressed = btn.getAttribute('aria-pressed');
            const heartWrap = btn
                .closest('.swym-wishlist-collections-v2-container')
                .closest('.card-wrapper.product-card-wrapper')
                .querySelector('.heart-view-wrap');

            if (pressed === 'true') {
                heartWrap.classList.add('active');
            } else {
                heartWrap.classList.remove('active');
            }
        });
    }, 2500);
}
// ------------filter click -------------
function runFilter() {
    console.log("hello");
    setTimeout(function() {
    $('.swym-wishlist-collections-v2-container button.swym-wishlist-collections-v2').each(function () {
      let pressed = $(this).attr('aria-pressed');
        console.log(pressed);
      let card = $(this)
        .parents('.swym-wishlist-collections-v2-container')
        .siblings('.card__inner')
        .find('.heart-view-wrap');
    if (pressed === 'true') {
        card.addClass('active');
    } else {
        card.removeClass('active');
    }
  });
},2500);
}

document.addEventListener('click', function (e) {
    if (e.target.closest('.facets__label, a.active-facets__button.active-facets__button--light')) {
        runFilter();
    }
});
document.addEventListener('input', function(e) {
    if (e.target.id === 'Filter-Price-LTE') {
        runFilter();
    }
});
    
document.addEventListener('input', function(e) {
    if (e.target.id === 'Filter-Price-GTE') {
        runFilter();
    }
})
document.addEventListener('change', function (e) {
    if (e.target.closest('select#SortBy')) {
        runFilter();
    }
});


    
